import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress";

import styles from "./styles";


const PageLoadingIndicator = ({classes, loadingMsg}) => {
  return (
    <div className={classes.preloaderContainer}>
      <CircularProgress className={classes.loadingIndicator}/>
      {!!loadingMsg && <div style={{marginLeft:'1.5em'}}>{loadingMsg}</div>}
    </div>
  )
};

export default withStyles(styles)(PageLoadingIndicator);